import { render, staticRenderFns } from "./WorkTaskList.vue?vue&type=template&id=2be2f8fb"
import script from "./WorkTaskList.vue?vue&type=script&lang=js"
export * from "./WorkTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports